/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from 'common/react/utils/translations';
import { SvgIcon } from 'common/react/components/SvgIcon';

const LAST_UPDATED_FORMAT = 'h:mmA dddd, MMMM D, YYYY';

export const TLCondensedLastUpdated = ({ lastUpdated, selectedRegion }) => (
    <div className="team-lineups__last-updated">
        <SvgIcon icon="info" className="icon" />
        <p>
            {getTranslation('label.teamlineups.lastUpdated')}
            <span>
                {lastUpdated
                    .tz(selectedRegion.timezone)
                    .format(LAST_UPDATED_FORMAT)}
            </span>
        </p>
    </div>
);

TLCondensedLastUpdated.propTypes = {
    lastUpdated: PropTypes.object.isRequired,
    selectedRegion: PropTypes.string.isRequired
};
